import { render, staticRenderFns } from "./PaginationCustom.vue?vue&type=template&id=6b5a7153&scoped=true&"
import script from "./PaginationCustom.vue?vue&type=script&lang=js&"
export * from "./PaginationCustom.vue?vue&type=script&lang=js&"
import style0 from "./PaginationCustom.vue?vue&type=style&index=0&id=6b5a7153&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5a7153",
  null
  
)

export default component.exports